import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { InfoSpedizioniVini } from '../../_classi/InfoSpedizioniVini';
import { VinoItem } from '../../_classi/VinoItem';
import { CantinaService } from '../../_servizi/cantina.service';
import { CarrelloViniService } from '../../_servizi/carrelloVini.service';
import { MessageServiceService } from '../../_servizi/message-service.service';
import { PacchettoItem } from 'src/app/_classi/PacchettoItem';

function TRANSLATE(str: string) {
  return str;
}
@Component({
  selector: 'app-vini-vendibili-layout-colonne',
  templateUrl: './vini-vendibili-layout-colonne.component.html',
  styleUrls: ['./vini-vendibili-layout-colonne.component.css']
})
export class ViniVendibiliLayoutColonneComponent implements OnInit, OnChanges {

  @Input() codiceForm: any;
  @Input() fromBase: boolean;
  @Input() pacchetti: PacchettoItem[];
  @Input() vinoSelezionatoFrombase: VinoItem;
  @Input() linguaCorrente: string;
  @Input() vini: VinoItem[];

  @Output() goBack = new EventEmitter<any>();
  @Output() filtraPacchetti = new EventEmitter<any>();
  @Output() selezionaVinoEmit = new EventEmitter<any>();


  vinoSelezionato: VinoItem = null;
  vino: VinoItem = null;
  viniFiltered: VinoItem[] = [];

  filtroProdotto = null;
  prodotti = [
    { id: '0', label_traduzione: TRANSLATE('base.tutti'), label: 'Tutti', visible: true },
    { id: '6', label_traduzione: TRANSLATE('base.winebox'), label: 'WineBox', visible: true },
    { id: '1', label_traduzione: TRANSLATE('base.rosso'), label: 'Rosso', visible: true },
    { id: '2', label_traduzione: TRANSLATE('base.bianco'), label: 'Bianco', visible: true },
    { id: '3', label_traduzione: TRANSLATE('base.rosato'), label: 'Rosato', visible: true },
    { id: '4', label_traduzione: TRANSLATE('base.spumante'), label: 'Spumante', visible: true },
    { id: '5', label_traduzione: TRANSLATE('base.altri'), label: 'Altri prodotti', visible: true },
  ];
  prodottiVisibili = [];

  infoSpedizioni: InfoSpedizioniVini;

  canBack = true;

  showLastStep = false;

  constructor(
    private messageService: MessageServiceService,
    private cantinaService: CantinaService,
    private carrelloService: CarrelloViniService
  ) { }


  ngOnChanges(changes: SimpleChanges): void {
    this.viniFiltered = this.vini;
    let i = 0;
    for (const prodotto of this.prodotti) {
      if (i != 0) {
        if (prodotto.label !== 'WineBox') {
          prodotto.visible = this.vini.filter(
            vino => vino.colore_id && vino.colore_id === prodotto.id
          ).length > 0 ? true : false;
        }
      }
      i++;
    }
    this.prodottiVisibili = this.prodotti.filter(prodotto => prodotto.visible);
    this.infoSpedizioni = this.cantinaService.getInfoSpedizioniSconti();
    if (this.vinoSelezionatoFrombase) {
      this.vinoSelezionato = this.vinoSelezionatoFrombase;
      this.scrollTO('box__scroll', 100)
    }

  }

  ngOnInit(): void {
    this.filtroProdotto = this.prodottiVisibili[0].label;
  }


  tornaIndietro(tipo) {
    switch (tipo) {
      case 'base':
        this.goBack.emit();
        break;
      case 'colonne':
        this.vinoSelezionato = null;
        const idx = this.cantinaService.getIdxViSelezionato();
        if (idx) {
          this.scrollTO('vino__' + idx, 500);
        }
        this.selezionaVinoEmit.emit(false);
        break;
    }
  }

  goToLast() {
    this.showLastStep = true;
    this.scrollTO('last_step', 500);
  }


  scrollTO(target, time) {
    setTimeout(() => {
      document.getElementById(target).scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest"
      });
    }, time);
  }

  filtra(filtro) {
    switch (filtro) {
      case 'Tutti':
        this.viniFiltered = this.vini;
        break;
      case 'WineBox':
        this.viniFiltered = [];
        break;
      default:
        this.viniFiltered = this.vini.filter(vino => vino.colore_id === filtro || filtro === '0');
    }
    this.filtraPacchetti.emit(filtro);
  }

  selezionaVino(obj) {
    this.vinoSelezionato = obj.vino;
    if (!this.fromBase) {
      this.cantinaService.setIdxViSelezionato(obj.idx);
      this.showLastStep = true;
      this.scrollTO('topbase', 100);
      this.selezionaVinoEmit.emit(true)
    }
  }

  menageVisibility(vino) {
    if (this.vinoSelezionato) {
      if (this.vinoSelezionato.id == vino.id) {
        return 'vedi';
      } else {
        return 'nascosto';
      }
    } else {
      return 'vedi';
    }
  }

}
